@if (groupedValidationErrors) {
<div class="validation-blockquote" data-testid="validation-errors-container">
   <p class="bq-title validation-bq-title" data-testid="validation-errors-title">
      @if (validationErrors.status === 400) {
         <span>Validation </span>
      }
      @if (validationErrors.status === 403) {
         <span>Authorization </span>
      }
      <span>Error{{validationErrors.errors.length > 1 ? 's' : ''}}</span>
   </p>

   <div class="validation-groups">
      @for (groupedError of groupedValidationErrors; track groupedError; let i = $index) {
      <div class="validation-group" [attr.data-testid]="'validation-errors-group-' + i">
         <!-- <span class="validation-property"> {{ groupedError.property}} </span> //TODO: uncomment after grouping is added -->
         <div class="validation-messages">
            @for (error of groupedError.errors | validationErrorBody: validationErrors.status; track error; let j = $index) {
            <span class="validation-error-message" [attr.data-testid]="'validation-errors-message-' + i + '-' + j">
               <telenet-icon name="error" class="validation-error-message__icon"></telenet-icon>
               <span class="validation-error-message-body">{{ error | translate }}</span>
            </span>
            }
         </div>
      </div>
      }
   </div>
</div>
}
